<template>
  <div class="container-fluid">
    <div v-if="user" class="col-4">
      <User :user="user" />
    </div>
  </div>
</template>

<script>
import User from '../components/User';
import { getUser } from '../api/user';

export default {
  mounted() {
    this.getUserProfile();
  },
  components: {
    User
  },
  data() {
    return {
      user: null 
    }
  },
  methods: {
    async getUserProfile() {
      try {
        const { data } = await getUser();
        const { user } = data;
        this.user = user;
      } catch (e) {
        console.log(e);
      }
    },
  }
}  
</script>
